/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScreenerInsuranceType } from './ScreenerInsuranceType';
import {
    ScreenerInsuranceTypeFromJSON,
    ScreenerInsuranceTypeFromJSONTyped,
    ScreenerInsuranceTypeToJSON,
} from './ScreenerInsuranceType';

/**
 * 
 * @export
 * @interface MarkPayerAsInnRequest
 */
export interface MarkPayerAsInnRequest {
    /**
     * 
     * @type {string}
     * @memberof MarkPayerAsInnRequest
     */
    facility_id: string;
    /**
     * 
     * @type {Array<ScreenerInsuranceType>}
     * @memberof MarkPayerAsInnRequest
     */
    insurance_types?: Array<ScreenerInsuranceType>;
}

/**
 * Check if a given object implements the MarkPayerAsInnRequest interface.
 */
export function instanceOfMarkPayerAsInnRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;

    return isInstance;
}

export function MarkPayerAsInnRequestFromJSON(json: any): MarkPayerAsInnRequest {
    return MarkPayerAsInnRequestFromJSONTyped(json, false);
}

export function MarkPayerAsInnRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkPayerAsInnRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'insurance_types': !exists(json, 'insurance_types') ? undefined : ((json['insurance_types'] as Array<any>).map(ScreenerInsuranceTypeFromJSON)),
    };
}

export function MarkPayerAsInnRequestToJSON(value?: MarkPayerAsInnRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_id': value.facility_id,
        'insurance_types': value.insurance_types === undefined ? undefined : ((value.insurance_types as Array<any>).map(ScreenerInsuranceTypeToJSON)),
    };
}

